const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20poster%20style%20image%20with%20dramatic%20cinematic%20lighting%2C%20solitary%20figure%20standing%20in%20rain%20under%20streetlamp%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20classic%20movie%20poster%20composition%2C%20grainy%20texture%2C%20emotional%20and%20atmospheric&width=400&height=560&seq=card-poster-01&orientation=portrait',
    title: '雨夜迷踪',
    category: '悬疑 / 犯罪',
    desc: '一名私家侦探在雨夜接到神秘委托，揭开隐藏十年的惊天秘密。豆瓣开分 9.1。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20showing%20astronaut%20floating%20in%20deep%20space%20with%20distant%20stars%20and%20nebula%2C%20epic%20scale%2C%20mysterious%20planet%20in%20background%2C%20sci-fi%20adventure%20aesthetic%2C%20dramatic%20contrast%20between%20bright%20cosmic%20light%20and%20dark%20void%2C%20inspirational%20and%20breathtaking%20composition&width=400&height=560&seq=card-poster-02&orientation=portrait',
    title: '太空救援：新纪元',
    category: '科幻 / 冒险',
    desc: '人类首次登陆系外行星，却发现这颗星球隐藏着改变一切文明的秘密。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20with%20couple%20dancing%20under%20string%20lights%20in%20a%20garden%2C%20soft%20golden%20evening%20light%2C%20vintage%20aesthetic%2C%20dreamy%20bokeh%20background%2C%20warm%20nostalgic%20feeling%2C%20tender%20and%20emotional%20atmosphere%2C%20classic%20romance%20film%20poster%20style&width=400&height=560&seq=card-poster-03&orientation=portrait',
    title: '那年夏天不说再见',
    category: '爱情 / 青春',
    desc: '高考前最后一个夏天，三个少年之间交错的情感与成长。年度最催泪青春片。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20explosive%20car%20chase%20scene%2C%20sparks%20flying%2C%20intense%20orange%20and%20red%20flames%20against%20dark%20urban%20background%2C%20dynamic%20motion%20blur%2C%20high%20adrenaline%20action%20aesthetic%2C%20blockbuster%20film%20poster%20style%20with%20dramatic%20lighting%20and%20cinematic%20composition&width=400&height=560&seq=card-poster-04&orientation=portrait',
    title: '极速狂飙 3',
    category: '动作 / 犯罪',
    desc: '全球票房冠军续作，超跑追逐与街头激战的视觉盛宴，肾上腺素飙升。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20movie%20poster%20with%20young%20heroine%20standing%20in%20a%20magical%20forest%20with%20glowing%20creatures%2C%20soft%20watercolor%20aesthetic%2C%20ethereal%20lighting%2C%20fantasy%20adventure%20theme%2C%20beautiful%20hand-drawn%20illustration%20style%2C%20warm%20and%20enchanting%20atmosphere%2C%20Studio%20Ghibli%20inspired&width=400&height=560&seq=card-poster-05&orientation=portrait',
    title: '月光森林的秘密',
    category: '动画 / 奇幻',
    desc: '宫崎骏风格原创动画，少女与月光下森林精灵的奇幻冒险之旅。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          精选推荐
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          编辑团队精选，本周不可错过的五部好片
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden group cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <span className="text-background-50 text-xs font-medium">{card.category}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 font-heading">
                  {card.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{card.category}</p>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}